import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/imgs/qrCode/qrCode1.png'


const _withScopeId = n => (_pushScopeId("data-v-80abf52a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "MajorSituationBackground" }
const _hoisted_2 = { id: "MajorSituationBody" }
const _hoisted_3 = { id: "MajorSituationBodyLeft" }
const _hoisted_4 = {
  key: 2,
  class: "greyBackgroundContainer"
}
const _hoisted_5 = { class: "greyBackgroundText" }
const _hoisted_6 = {
  key: 4,
  class: "greyBackgroundContainer"
}
const _hoisted_7 = { class: "greyBackgroundText" }
const _hoisted_8 = {
  key: 6,
  class: "greyBackgroundContainer"
}
const _hoisted_9 = { class: "greyBackgroundText" }
const _hoisted_10 = {
  key: 8,
  class: "greyBackgroundContainer"
}
const _hoisted_11 = { class: "greyBackgroundText" }
const _hoisted_12 = {
  key: 10,
  class: "greyBackgroundContainer"
}
const _hoisted_13 = { class: "greyBackgroundText" }
const _hoisted_14 = {
  key: 12,
  class: "greyBackgroundContainer"
}
const _hoisted_15 = { class: "greyBackgroundText" }
const _hoisted_16 = { id: "MajorSituationFooter" }
const _hoisted_17 = { id: "instructions" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "instructionsTitle" }, "系统使用说明", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "formText" }, "本查询系统数据来源于教育部官网、阳光高考、各省教育考试院、各院校官网及招生就业网、软科官网、中国科教评价网、麦可思研究院等，数据仅供参考，具体数据请以学校官网或考试院最新公布为准。", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "formText" }, "本站数据未经授权严禁转载，违者将依法追究责任。", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "formText" }, "如对本系统或相关服务有任何疑问，可拨打电话400-018-0810反馈于我们。", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "qrCodeContainer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "qrCodeItem" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ])
], -1))

import RightTitle from '@/components/collegeSituation/RightTitle.vue'
  import LeftTitle from '@/components/collegeSituation/LeftTitle.vue'
  import {useRoute, useRouter} from 'vue-router'
  import {ref, reactive, nextTick, onMounted, computed} from 'vue'
  import {
    baseURL,
    downloadMajorTargetRank,
    getMajorInfo,
    getMajorTargetRank, majorsGetMajorRanks, majorsGetMajorRanksType
  } from "@/network/axios";


  
export default /*#__PURE__*/_defineComponent({
  __name: 'MobileProfessionSituation',
  props: ['professionInfo'],
  setup(__props) {

const props = __props;

  let route = useRoute();
  let router = useRouter();

  


  //如果页面左半部 都没有
  let noDataImg = computed(() => {
    if (props.professionInfo.definition == '' && props.professionInfo.developmentSpace == '' && props.professionInfo.jobRequire == '' && props.professionInfo.occIntroduction == '' && props.professionInfo.occTrait == '' && props.professionInfo.workContact == '' ) {
      return true
    } else {
      return false
    }
  });



return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(noDataImg))
          ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 0,
              "image-size": 180,
              description: "暂无数据"
            }))
          : _createCommentVNode("", true),
        (_unref(props).professionInfo.definition!='')
          ? (_openBlock(), _createBlock(LeftTitle, {
              key: 1,
              title: "岗位定义"
            }))
          : _createCommentVNode("", true),
        (_unref(props).professionInfo.definition!='')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(props).professionInfo.definition), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(props).professionInfo.occIntroduction!='')
          ? (_openBlock(), _createBlock(LeftTitle, {
              key: 3,
              title: "职业介绍"
            }))
          : _createCommentVNode("", true),
        (_unref(props).professionInfo.occIntroduction!='')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(props).professionInfo.occIntroduction), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(props).professionInfo.occTrait!='')
          ? (_openBlock(), _createBlock(LeftTitle, {
              key: 5,
              title: "职业特点"
            }))
          : _createCommentVNode("", true),
        (_unref(props).professionInfo.occTrait!='')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(props).professionInfo.occTrait), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(props).professionInfo.workContact!='')
          ? (_openBlock(), _createBlock(LeftTitle, {
              key: 7,
              title: "工作联系"
            }))
          : _createCommentVNode("", true),
        (_unref(props).professionInfo.workContact!='')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(props).professionInfo.workContact), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(props).professionInfo.jobRequire!='')
          ? (_openBlock(), _createBlock(LeftTitle, {
              key: 9,
              title: "任职条件"
            }))
          : _createCommentVNode("", true),
        (_unref(props).professionInfo.jobRequire!='')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(props).professionInfo.jobRequire), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(props).professionInfo.developmentSpace!='')
          ? (_openBlock(), _createBlock(LeftTitle, {
              key: 11,
              title: "发展空间"
            }))
          : _createCommentVNode("", true),
        (_unref(props).professionInfo.developmentSpace!='')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(props).professionInfo.developmentSpace), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(_component_el_form, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "1." }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "2." }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "3." }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_22
  ]))
}
}

})